import axios from "axios";

import {
  ResponseList,
  ResponseItem,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";

import {CompanyListParams, EQCompany} from "../../models/serverModels/EQCompany";

const company = axios.create({
  baseURL: "/api",
});

export const getList = async (params: CompanyListParams): Promise<ResponseList<EQCompany>> =>
  company({
    url: "/companyList",
    method: "get",
    params,
  }).then((res) => res.data);

export const getItem = async (params: Params.GetItem): Promise<ResponseItem<EQCompany>> =>
  company({
    url: `/company/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const create = async (params: Params.Create<EQCompany>): Promise<ResponseItem<EQCompany>> =>
  company({
    url: `/company`,
    method: "post",
    data: params,
  }).then((res) => res.data);

export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  company({
    url: `/company/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);

export const update = async (params: Params.Update<EQCompany>): Promise<ResponseItem<EQCompany>> =>
  company({
    url: `/company/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);
